const el = document.querySelector<HTMLInputElement>('#cart_email, input[name="cart_email"]');

function debounce<F extends (...args: any[]) => void>(fn: F, ms = 400) {
    let t: number | undefined;
    return (...args: Parameters<F>) => {
        if (t) window.clearTimeout(t);
        t = window.setTimeout(() => fn(...args), ms);
    };
}

async function sendEmailToServer(email: string) {
    if (!email) return;
    const looksLikeEmail = /\S+@\S+\.\S+/.test(email);
    if (!looksLikeEmail) return;

    try {
        await fetch((window as any).CartEmailAjax.url, {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
            body: new URLSearchParams({
                action: 'set_prefill_email',
                _ajax_nonce: (window as any).CartEmailAjax.nonce,
                email,
            }).toString(),
            credentials: 'same-origin',
        });
    } catch {
        // silently ignore; server-side prefill is best-effort
    }
}

if (el) {
    const handler = debounce(() => sendEmailToServer(el.value), 500);
    el.addEventListener('input', handler);
    el.addEventListener('blur', () => sendEmailToServer(el.value));
}


// Edits to checkout form to only show BTW nummer field if company name is filled in
document.addEventListener('DOMContentLoaded', () => {
    const checkoutForm = document.querySelector('.woocommerce-checkout') as HTMLFormElement | null;
    if (!checkoutForm) return;

    const companyNameField = checkoutForm.querySelector('#billing_company') as HTMLInputElement | null;
    const countryField = checkoutForm.querySelector('#billing_country') as HTMLSelectElement | null;
    const vatNumberWrapper = checkoutForm.querySelector('#vat_number_field') as HTMLDivElement | null;

    if (!companyNameField || !vatNumberWrapper) {
        console.warn("Company name field or VAT number field not found in checkout form.");
    }

    const toggleVatNumberField = () => {
        const companyValue = companyNameField ? companyNameField.value.trim() : null;

        if (!companyValue || !vatNumberWrapper) {
            return;
        }

        if (companyValue && companyValue !== '') {
            vatNumberWrapper.classList.add('active');
        } else {
            vatNumberWrapper.classList.remove('active');
            const vatNumberInput = vatNumberWrapper.querySelector('input') as HTMLInputElement | null;
            if (vatNumberInput) {
                vatNumberInput.value = '';
            }
        }
    };

    toggleVatNumberField();
    companyNameField?.addEventListener('input', toggleVatNumberField);

    if (countryField) {
        countryField.addEventListener('change', toggleVatNumberField);
    }

    document.body.addEventListener('updated_checkout', toggleVatNumberField);
    document.body.addEventListener('init_checkout', toggleVatNumberField);
    document.body.addEventListener('payment_method_selected', toggleVatNumberField); // just in case
});
